













































































































import Vue from 'vue';
import Overlay from '../../layout/Overlay.vue';
import TextInput from '../../myprofile/inputs/TextInput.vue';
import CustomButton from '../../layout/buttons/CustomButton.vue';

export default Vue.extend({
  components: { CustomButton, Overlay, TextInput },
  computed: {
    image(): string {
      const image = this.merchandiseOverlay.item?.image ?? ``;
      return image ? `${image}&w=500` : ``;
    },
  },
  props: {
    merchandiseOverlay: {
      required: true,
      type: Object,
    },
  },
  methods: {
    updateBusinessCard(): void {
      this.$emit(`update:business-card`);
    },
  },
});
